export const tiposConta = [{
  name: 'Conta Corrente',
  value: 'ContaCorrente'
}, {
  name: 'Conta Poupança',
  value: 'ContaPoupanca'
}];
